import React from 'react';

const DEFAULT_STEPS = [];

const HowItWorks = ({ steps = DEFAULT_STEPS }) => (
  <div className="cp-how">
    {steps.map((s, i) => {
      const Icon = s.Icon;
      return (
        <div className="cp-how-step" key={s.title}>
          <div className="cp-how-step-num">{String(i + 1).padStart(2, '0')}</div>
          <div className="cp-how-step-icon"><Icon size={20} /></div>
          <h4 className="cp-how-step-title">{s.title}</h4>
          <p className="cp-how-step-text">{s.text}</p>
          {i < steps.length - 1 && <div className="cp-how-connector" aria-hidden="true" />}
        </div>
      );
    })}
  </div>
);

export default HowItWorks;
